import * as RadixTooltip from "@radix-ui/react-tooltip"
import {
  type ComponentPropsWithoutRef,
  forwardRef,
  type ReactNode,
} from "react"

export const TooltipProvider = RadixTooltip.Provider

export type TooltipProps = Pick<
  ComponentPropsWithoutRef<typeof RadixTooltip.Root>,
  "defaultOpen" | "open" | "onOpenChange" | "delayDuration"
> &
  Pick<
    ComponentPropsWithoutRef<typeof RadixTooltip.Content>,
    "side" | "align" | "collisionPadding"
  > & {
    children: ReactNode
    content: ReactNode | null
  } & Omit<ComponentPropsWithoutRef<"div">, "content">

export const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(
  (
    {
      children,
      content,
      open,
      defaultOpen,
      onOpenChange,
      delayDuration,
      side,
      collisionPadding,
      align,
      className,
      ...props
    },
    ref,
  ) => {
    if (!content) {
      return <>{children}</>
    }

    return (
      <RadixTooltip.Root
        open={open}
        defaultOpen={defaultOpen}
        onOpenChange={onOpenChange}
        delayDuration={delayDuration}
      >
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            ref={ref}
            side={side}
            align={align}
            collisionPadding={collisionPadding}
            {...props}
            className={`tooltip ${className ?? ""}`}
          >
            {content}
            <RadixTooltip.Arrow
              className="tooltip-arrow"
              width={11}
              height={5}
            />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    )
  },
)

Tooltip.displayName = "Tooltip"
